import { Ecode, EcodeStr, ECODE_REGEX } from '@csp/csp-common-model';
import { InputValidators } from '@csp/csp-common-form';

/**
 * Extract an E-code from a string
 */
const from = (ecodeStr: EcodeStr): Ecode => {
  const trimmedEcode = ecodeStr ? ecodeStr.trim() : ecodeStr;
  const siteNumberStr = trimmedEcode && trimmedEcode.length === 8 ? trimmedEcode.substring(1, 5) : undefined;
  const siteNumber = isNaN(Number(siteNumberStr)) ? undefined : siteNumberStr;
  return {
    asString: trimmedEcode,
    siteNumber,
  };
};

/**
 * Validate before extraction of an E-code
 */
const fromValidated = (ecodeStr: EcodeStr): Ecode => {
  const ecode = from(ecodeStr);
  if (!ecode.asString || InputValidators.ecode(ECODE_REGEX, '')(ecode.asString, '')?.type) {
    throw new Error(`Expected an E-code but got: ${ecodeStr}`);
  }
  return ecode;
};

export const EcodeFactory = {
  fromValidated,
  from,
};
